import { http } from "../http-common";

const FetchImportList = query => {
  if (query?.searchquery) {
    return http.get(`importLogHeader/${query?.entityName}?pageNumber=${query?.pageNumber}&pageSize=${query?.size}&startDate=${query?.startDate}&endDate=${query?.endDate}&keyword=${query?.searchquery}`);
  } else {
    return http.get(`importLogHeader/${query?.entityName}?pageNumber=${query?.pageNumber}&pageSize=${query?.size}&startDate=${query?.startDate}&endDate=${query?.endDate}`);
  }
};

const FetchLogsList = query => {
  if(query?.searchQuery){
    return http.get(`import-contract?pageNumber=${query?.pageNumber}&size=${query?.size}&importContractId=${query?.headerID}&status=${query?.searchQuery}`);
  } else {
    return http.get(`import-contract?pageNumber=${query?.pageNumber}&size=${query?.size}&importContractId=${query?.headerID}`);

  }
};

const FetchLogDetails = query => {
return http.get(`/import-contract/contract-details/${query?.headerID}/`);
};
const UploadFile = query => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }
  return http.post(`/importLogHeader/${query?.entityName}?usuername=${query?.username}&importDate=${query?.importDate}&importTime=${query?.importTime}&comments=${query?.comment}`, query?.file, config);
};



const DownloadFile = query => {
  const config = {
    headers: {
      'Content-Type': 'application/octet-stream',
      'Accept': 'application/octet-stream'
    }
  }
  const params = new URLSearchParams();
  params.append("isTemplate", query?.isTemplate);
  if (query?.cropYear) {
    params.append("cropYear", query.cropYear);
  }

  return http.get(`/importLogHeader/template/${query?.name}?${params.toString()}`, config);
};


const downloadContract =(cropYear)=> {
  return http.get(`/import-contract/template/${cropYear}`);
};

const DownloadExcelFile = query => {
  const config = {
    responseType:'blob',
    headers: {
      'accept': 'application/octet-stream',
    }
  }
  return http.get(`/importLogHeader/template/${query?.name}?isTemplate=${query?.isTemplate}`, config);
};
const ExportAll = query => {
  
  return http.get(`/importLogHeader/exportFile/${query?.ilHeaderId}`);
};

////////Hierarchy  Methods Start ////////////////
const ImportHierarchyProcessStart = id => {
  return http.post(`/hierarchy-import/start-process/${id}`);
};

const GetImportHierarchyLogProgress = id => {
  return http.get(`/hierarchy-import/progress/${id}`);
};
const ImportHierarchyLogCancel = id => {
  return http.post(`/hierarchy-import/cancel/${id?.id}`);
};
////////Hierarchy  Methods END ////////////////

//////////Farmer start////////
const UploadStartProcess = id => {
  return http.post(`/farmer-import/start-process/${id}`);
};
const UploadProgress = id => {
  return http.get(`/farmer-import/progress/${id}`);
};
const UploadCancel = id => {
  return http.post(`/farmer-import/cancel/${id?.id}`);
};
//////////Farmer end////////

//////////Wood Supplier start////////
const UploadWoodSupplierProcessStart = id => {
  return http.post(`/wood-supplier-import/start-process/${id}`);
};

const GetWoodSupplierLogProgress = id => {
  return http.get(`/wood-supplier-import/progress/${id}`);
};

const WoodSupplierLogCancel = id => {
  return http.post(`/wood-supplier-import/cancel/${id?.id}`);
};
//////////Wood Supplier end////////

//////////Contract start////////
const ImportContractProcessStart = id => {
  return http.post(`/import-contract/transfer-data` ,`{"import-id":"${id}"}`);
};
const GetImportContractLogProgress = id => {
  return http.get(`/import-contract/progress/${id}`);
};
const ImportContractLogCancel = id => {
  return http.post(`/import-contract/cancel/${id?.id}`);
};
//////////Contract end////////

const fetchImportStatusAPI = (query) => {
  return http.get(`/${query?.entityName}/status/${query?.IlHeaderId}`);
};

/////FT FA Mapping API///////
const FetchAllFTtoFAViewLog = (query) => {
  const params = new URLSearchParams();
  params.append("pageNumber", query.pageNumber);
  params.append("size", query.size);
  if (query.status) {
    params.append("status", query.status);
  }
  if (query.keyword) {
    params.append("keyword", query.keyword);
  }

  return http.get(`/ft-fa-mapping-import/logs?importId=${query.id}&${params.toString()}`);
};
const UploadFTFAProcessStart = id => {
  return http.post(`/ft-fa-mapping-import/start-process/${id}`);
};

const GetFTFALogProgress = id => {
  return http.get(`/ft-fa-mapping-import/progress/${id}`);
};

const FTFALogCancel = id => {
  return http.post(`/ft-fa-mapping-import/cancel/${id?.id}`);
};

const ImportService = {
  FetchImportList,
  UploadFile,
  UploadStartProcess,
  UploadProgress,
  UploadCancel,
  DownloadFile,
  ExportAll,
  ImportHierarchyProcessStart,
  GetImportHierarchyLogProgress,
  ImportHierarchyLogCancel,
  ImportContractProcessStart,
  GetImportContractLogProgress,
  ImportContractLogCancel,
  FetchLogsList,
  FetchLogDetails,
  fetchImportStatusAPI,
  DownloadExcelFile,
  downloadContract,
  UploadWoodSupplierProcessStart,
  GetWoodSupplierLogProgress,
  WoodSupplierLogCancel,
  FetchAllFTtoFAViewLog,
  UploadFTFAProcessStart,
  GetFTFALogProgress,
  FTFALogCancel
};

export default ImportService;

